import React, { Fragment, useContext } from 'react';
import { useState, useEffect, useRef, useMemo } from 'react';
import useLoader from "../../hooks/useLoader";
import { useMsal } from "@azure/msal-react";
import classes from "./ReportScreenPopup.module.css";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { Box, FormControl, FormHelperText, Grid, Grid2, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography, Button, styled, OutlinedInput, Checkbox, ListItemText, filledInputClasses } from '@mui/material';
import { Api, Close, ConstructionOutlined, KeyboardDoubleArrowRight, PriorityHigh } from '@mui/icons-material';
import { DUAL_ACCOUNT_REPORT, FUTURE_COVERAGE_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT } from '../../constants/reportNames';
import { useGetSurveyScreenData } from '../../queries/useGetSurveyScreenData';
import Snackbar from '@mui/material/Snackbar';
import Loader from "../UI/Loader";
import Alert from '@mui/material/Alert';
import { ChangedConditions, ParsedConditions, REPORT_CONDITONS } from '../../constants/reportConditions';
// import { useUpdateWorkbenchData } from '../../hooks/useUpdateWorkbenchData';
import { getMSID, getToken } from '../../authfile';
import { useUpdateSaveAnswers } from '../../queries/useUpdateSaveAnswers';
import { COMPLETED, COMPLETE_Question_Of_Report, SAVE, SAVEDRAFT } from '../../constants/miscConstants';
import { useSnackbar } from 'notistack';
import { UserContext } from '../../hooks/UserContext';
import { Columns_With_Date } from '../../constants/miscConstants';
import WithConditional from '../hoc/WithConditional';
import { CSTDateFormatterWithTime_12_hr } from '../../utils/DateFormatter';
import { useSurveyScreenData } from '../../hooks/useSurveyScreenData';
import CustomizedSnackbars from '../UI/SnackBar';
import AppInsight from '../Azure/AppInsights';
import useLoaderStore from '../../store';


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'left',
  boxShadow: ' 0px 0px 4px rgba(0, 0, 0, 0.1), 0px 0px 5px rgba(0, 0, 0, 0.07), 0px 0px 10px rgba(0, 0, 0, 0.06)',
  color: theme.palette.text.secondary,
  margin: '1rem',
  padding: '1rem'
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '0.2rem solid #002277',
  boxShadow: 24,
  px: 3,
  overflow: 'auto',
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultiSelectComponent = ({ fieldItem,
  fieldValue,
  error,
  setError,
  Validations,
  handleChange,
}) => {
  const values = fieldValue == "" ? [] : fieldValue.split(',')
  //console.log("fieldvalue", fieldValue);
  return (
    <Grid2 size={4}>
      <Stack
        alignItems="start"
        spacing={1}
      >
        <label style={{ fontWeight: 'bold' }} title={fieldItem.question_text.length > 80 && fieldItem.question_text}>{fieldItem.question_text.substr(0, 80) + (fieldItem.question_text.length > 80 ? "..." : "")}</label>
        <FormControl sx={{ m: 1, width: 300 }}>
          <InputLabel id="demo-multiple-name-label">{fieldItem.question_text.substr(0, 30) + (fieldItem.question_text.length > 80 ? "..." : "")}  </InputLabel>
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            multiple
            value={values}
            onChange={(e) => handleChange(e, fieldItem.id)}
            input={<OutlinedInput label="Tag" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {fieldItem.values?.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={fieldValue.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Grid2>
  )
}

const RadioComponent = ({ fieldItem,
  fieldValue,
  error,
  setError,
  Validations,
  handleChange,
}) => (
  <Grid2 size={4}>
    <FormControl>
      <FormLabel id="demo-controlled-radio-buttons-group">{fieldItem.question_text}</FormLabel>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={fieldValue}
        onChange={(e) => handleChange(e, fieldItem.id)}
      >
        {fieldItem.values?.map((eachValue) => (
          <FormControlLabel value={eachValue} control={<Radio />} label={eachValue} />
        ))}

      </RadioGroup>
    </FormControl>
  </Grid2>

);

const DropDownComponent = ({
  fieldItem,
  fieldValue,
  error,
  setError,
  Validations,
  handleChange,

}) => (


  <Grid2 size={4}>
    <Stack
      alignItems="start"
      spacing={1}
    >
      <label style={{ fontWeight: 'bold' }} title={fieldItem.question_text.length > 80 && fieldItem.question_text}>{fieldItem.question_text.substr(0, 80) + (fieldItem.question_text.length > 80 ? "..." : "")}</label>
      <FormControl size="small" sx={{ width: '100%' }} error={error ? true : false}>
        <InputLabel id="demo-simple-select-error-label">{fieldItem.question_text.substr(0, 30) + (fieldItem.question_text.length > 80 ? "..." : "")}  </InputLabel>
        <Select
          labelId="demo-simple-select-error-label"
          id="demo-simple-select-error"
          value={fieldValue}
          label={fieldItem.question_text}
          onChange={(e) => handleChange(e, fieldItem.id)}
          fullWidth
        >
          {fieldItem.values?.map((eachValue) => (
            <MenuItem value={eachValue}>{eachValue}</MenuItem>
          ))}
        </Select>
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Stack>
  </Grid2>
);

const TextFieldComponent = ({
  fieldItem,
  fieldValue,
  error,
  setError,
  Validations,
  handleChange
}) => (
  <Grid2 size={4}>
    <Stack
      alignItems="start"
      spacing={2}
    >
      <label style={{ fontWeight: 'bold' }}>{fieldItem.question_text}</label>

      <TextField
        sx={{ m: 1 }}
        aria-labelledby="its-the-label"
        error={error ? true : false}
        id="filled-error-helper-text"
        value={fieldValue}
        helperText={error}
        placeholder={fieldItem.question_text}
        onChange={(e) => handleChange(e, fieldItem.id)}
        size="small"
        fullWidth
      />
    </Stack>
  </Grid2>
);



const ReportScreenPopup = ({ caseId, handleCloseReportPopup, reportName, status, role, closePopup }) => {

  const tokenConfig = {
    headers: {
      "Authorization": `Bearer ${getToken()}`,
    },
  };
  const [loader, showLoader, hideLoader] = useLoader();
  const [mount, setMount] = useState(false);
  const [response, setResponse] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const msid = getMSID();
  const { loaderData, setLoaderData } = useLoaderStore();
  const popupRef = useRef(null)

  // This is the hook which calls api to get the survey screen data
  // From this api, we are going to get the questions, options and pre-populated data 
  // if any
  // We are passing reportName, caseId for it
  const {
    data,
    isLoading,
    isError: isSurveyScreenDataError,
    error: surveyScreenDataError,
    isFetching
  } = useGetSurveyScreenData({
    body: {
      report: reportName,
      caseId: caseId,
    }, config: tokenConfig
  })

  // const {
  //   data: x
  // } = useSurveyScreenData({
  //   report: reportName,
  //   caseId: caseId,
  // }, hideLoader)

  // We are using this function to format dropdown values in to an object format like 
  // {
  //   1: "yes", 2: "No"
  // }
  // where the format from api is different like this 
  // {
  //   id: '1',
  //   Drop_Down_Text: "Yes"
  // }
  const dropDownValues = useMemo(() => {
    let dropdownValues = {};
    if (data != null && data != undefined) {
      for (const x of data.DropdownData) {
        dropdownValues[x['Id']] = x['Drop_Down_Text']
      }
    }
    return dropdownValues;
  }, [data])

  // Some radio button questions need to have default values so we are checking 
  // id and returning the default values we need to have 
  const giveDefault = (id) => {
    if (id == 66) {
      return "No"
    }
    if (id == 67) {
      return "Yes"
    }
    if (id == 68) {
      return "No"
    }
    return '';
  }

  // This is very important function as we are formatting the data which we get from Api
  // into an object, where object contains questions, caseData, conditions and answers 
  const formattedData = useMemo(() => {
    let groupedData = {};
    if (data != null || data != undefined) {
      let groupDropdownvalues = {};
      let groupQuestions = [];
      let savedAnswers = {};
      for (const x of data.DropdownData) {
        const questionId = x['Survey_Question_Id'];
        if (groupDropdownvalues[questionId] == null || groupDropdownvalues[questionId] == undefined) {
          groupDropdownvalues[questionId] = [x['Drop_Down_Text']]
        } else {
          groupDropdownvalues[questionId].push(x['Drop_Down_Text'])
        }
      }
      for (const x of data.QuestionsData) {
        const questionId = x['question_id']
        groupQuestions.push({
          id: questionId,
          question_text: x['question_text'],
          values: groupDropdownvalues[questionId]
        })
      }
      for (const x of data.SurveyData) {
        savedAnswers[x['QuestionID']] = x['answer']
      }
      groupedData['questions'] = groupQuestions
      groupedData['CaseData'] = data['CaseData']?.[0]
      groupedData['conditions'] = JSON.parse(data['ConditionsData']?.[0]?.['CONDITION']);
      //groupedData['conditions'] = JSON.parse(ParsedConditions[reportName]);
      groupedData['answers'] = savedAnswers
    }
    return groupedData;
  }, [data]);

  // This useEffect will set the initial values for the response
  useEffect(() => {
    const initialState = {};
    if (formattedData != undefined && formattedData.questions != undefined) {
      for (const x of formattedData?.questions) {
        initialState[x.id] = formattedData['answers'][x.id] || (reportName == PART_D_IE_REPORT ? giveDefault(x.id) : '')
      }
    }
    setResponse(initialState);
  }, [formattedData])

  // The hook will updateTheAnswers Api when function called 
  const { mutateAsync: updateSaveAnswers, isLoading: isUpdatingSaveAnswers } =
    useUpdateSaveAnswers({ reportName });

  // The function will update the response based on the answer selected and updates the answers 
  // of the questions which are dependent on the response of this question
  const handleChange = (event, id) => {
    const newResponse = { ...response };
    if (reportName === DUAL_ACCOUNT_REPORT && id === 4) {
      newResponse[id] = event.target.value.join(',')
    } else {
      newResponse[id] = event.target.value;
    }
    for (const key in newResponse) {
      let populate = false;
      if (formattedData?.["conditions"]?.[key] != null) {
        for (let i = 0; i < formattedData["conditions"][key].length; i++) {
          let condition = formattedData["conditions"][key][i];
          let check = true;
          for (let j = 0; j < condition.length; j++) {
            let eachCondition = condition[j];
            if (checkCondition(eachCondition, newResponse) == false) {
              check = false;
              break;
            }
          }
          if (check) {
            populate = true;
            break;
          }
        }

        if (populate == false) {
          newResponse[key] = '';
        }
      }
    }
    setResponse(newResponse);

  }

  // This function will check the condition and returns true or false 
  // based on whether the condition is getting satisfied or not
  const checkCondition = (eachCondition, newResponse) => {
    if (eachCondition['key'] == 0) {
      //console.log("Here I am ",eachCondition)
      return formattedData['CaseData'][eachCondition['id']] == eachCondition['value_id']
    } else {
      if (Array.isArray(newResponse[eachCondition['id']])) {
        if (eachCondition['neq'] !== undefined) {
          return newResponse[eachCondition['id']].includes(dropDownValues[eachCondition['value_id']]) == false
        }
        return newResponse[eachCondition['id']].includes(dropDownValues[eachCondition['value_id']])
      }
      if (eachCondition['neq'] !== undefined) {
        return newResponse[eachCondition['id']] === undefined || newResponse[eachCondition['id']] !== dropDownValues[eachCondition['value_id']]
      }
      return newResponse[eachCondition['id']] == dropDownValues[eachCondition['value_id']]
    }

  }

  // This function will return true or false after checking all conditions of a particular question
  const checkPopulate = (fieldItem) => {
    let populate = false;
    if (formattedData?.["conditions"]?.[fieldItem.id] == null) {
      return true;
    }
    for (let i = 0; i < formattedData?.["conditions"][fieldItem.id].length; i++) {
      let condition = formattedData?.["conditions"][fieldItem.id][i];
      let check = true;
      for (let j = 0; j < condition.length; j++) {
        let eachCondition = condition[j];
        if (checkCondition(eachCondition, response) == false) {
          check = false;
          break;
        }
      }
      if (check) {
        populate = true;
        break;
      }
    }
    //console.log("fieldItem",fieldItem,"populate",populate);
    return populate;
  }

  // one report has questions which require radio buttons so we are checking before displaying component
  const checkRadioComponent = (id, reportName) => {
    if (reportName == PART_D_IE_REPORT && (id == 66 || id == 67 || id == 68)) {
      return true;
    }
    return false;
  }

  // Buttons of submit, saveDraft are visible only if status is not completed
  const checkVisibilityOfSave = () => {
    if (status != COMPLETED) {
      return true;
    }
    return false;
  }

  // This function will only allow to submit when all the answers of the questions are filled
  const checkValidationsBeforeSubmit = () => {
    let proceed = true;
    const allQuestions = formattedData['questions'];
    allQuestions.every((eachQuestion) => {
      if (checkPopulate(eachQuestion) == true) {
        if (response[eachQuestion['id']] == '' || response[eachQuestion['id']] == null || response[eachQuestion['id']] == undefined) {
          proceed = false;
          return false;
        }
      }
      return true;
    })
    return proceed;
  }
  useEffect(() => {

    if(isFetching || isUpdatingSaveAnswers){
      setLoaderData({ display: true, message: 'Loading...' });
    }else{
      setLoaderData({ display: false, message: '' });
    }

  },[isFetching, isUpdatingSaveAnswers])


  // console.log("formatted Data", formattedData);
  // console.log("dropdown Values", dropDownValues)
  // console.log("Entire data is", data);
  // sessionStorage.setItem("conditions",JSON.stringify(ParsedConditions));

  return (
    <Fragment>
   
      {/* <WithConditional when={isFetching || isUpdatingSaveAnswers}>
        <Loader />
      </WithConditional> */}
      <WithConditional when={isSurveyScreenDataError}>
        <CustomizedSnackbars type="error" API="Survey Screen Data API" message={surveyScreenDataError?.message} />
      </WithConditional>
      <Item elevation={2}>
        <Grid2 container rowSpacing={1}>
          <Grid2 size={12}>
            <Typography variant="p" color='secondary' sx={{ fontSize: '1.2rem', backgroundColor: '#002277', borderRadius: '0.2rem', width: 'fit-content', padding: '0rem 0.5rem' }}><KeyboardDoubleArrowRight /> CASE LOAD SECTION</Typography>
          </Grid2>
          {
            formattedData['CaseData'] && Object.keys(formattedData['CaseData']).map(key => (
              <Grid2 size={4}>
                <Typography variant="p" sx={{ fontWeight: 'bold' }}>{key} :</Typography>
                <Typography variant="body1" sx={{ display: 'inline', mx: 1 }}>{(Columns_With_Date[key] != null || Columns_With_Date[key] != undefined) ? Columns_With_Date[key](formattedData['CaseData'][key]) : ((key == "ISRESTRICTED" || key == "DUPRESTRICTED") ? (formattedData['CaseData'][key] == 1 ? "True" : "False") : formattedData['CaseData'][key])}</Typography>
              </Grid2>
            ))
          }
        </Grid2>
      </Item>
      <Item elevation={2}>
        <Grid2  container rowSpacing={3} columnSpacing={4}>
          <Grid2 size={12}>
            <Typography variant="p" color='secondary' sx={{ fontSize: '1.2rem', backgroundColor: '#002277', borderRadius: '0.2rem', width: 'fit-content', padding: '0rem 0.5rem' }}><KeyboardDoubleArrowRight /> TECHNICAL LOAD SECTION</Typography>
          </Grid2>
          {
            formattedData["questions"]?.map((fieldItem, index) => (
              <WithConditional when={checkPopulate(fieldItem) == true}>
                <WithConditional when={fieldItem.values === undefined}>
                  <TextFieldComponent
                    fieldItem={fieldItem}
                    fieldValue={response[fieldItem.id] || ''}

                    handleChange={handleChange}
                  />
                </WithConditional>
                <WithConditional when={fieldItem.values !== undefined}>
                  <WithConditional when={checkRadioComponent(fieldItem.id, reportName) == true}>
                    <RadioComponent fieldItem={fieldItem}
                      values={fieldItem.values}
                      fieldValue={response[fieldItem.id] || ''}

                      handleChange={handleChange}
                      defaultValue={giveDefault(fieldItem.id)} />
                  </WithConditional>
                  <WithConditional when={checkRadioComponent(fieldItem.id, reportName) == false}>
                    <WithConditional when={reportName === DUAL_ACCOUNT_REPORT && fieldItem.id === 4}>
                      <MultiSelectComponent
                        fieldItem={fieldItem}
                        values={fieldItem.values}
                        fieldValue={response[fieldItem.id]}

                        handleChange={handleChange}
                      />
                    </WithConditional>
                    <WithConditional when={(reportName !== DUAL_ACCOUNT_REPORT || fieldItem.id !== 4)}>
                      <DropDownComponent
                        fieldItem={fieldItem}
                        values={fieldItem.values}
                        fieldValue={response[fieldItem.id] || ''}

                        handleChange={handleChange}
                      />
                    </WithConditional>
                  </WithConditional>
                </WithConditional>
              </WithConditional>
            ))
          }
        </Grid2>


      </Item>
      {/* <WithConditional when={checkVisibilityOfSave()}> */}
      <Grid2 container sx={{ my: 2, justifyContent: 'flex-end' }}>
        <Grid2 size={2}>
          <Button variant="contained" color="primary" onClick={() => {
            //console.log("response is ", response);
             
              const result = updateSaveAnswers(
                {
                  body: {
                    values: response,
                    caseid: caseId,
                    user: getMSID(),
                    status: SAVEDRAFT,
                    report: reportName
                  }, config: tokenConfig
                })
              result.then(res => {
                if (res.data.error) {
                  throw new Error(res.data.message);
                }
                enqueueSnackbar("Save Draft was successful", {
                  variant: 'success'
                })
                

              })
                .catch(err => {
                  enqueueSnackbar(`something went wrong ${err.message}`, {
                    variant: 'error'
                  });
                  AppInsight.trackEvent({ name: `RQA => Saving draft answers Error, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in saving draft answers" } });

                });
            }
          }>Save Draft</Button>
        </Grid2>
        <Grid2 size={1}>
          <Button variant="contained" color="primary" onClick={() => {
            if (checkValidationsBeforeSubmit() == false) {
              enqueueSnackbar("Please answer all the questions before submit", {
                variant: 'warning'
              })
              return;
            }
            // const Complete_question_details = COMPLETE_Question_Of_Report[reportName];
            // if (Complete_question_details.question_id !== undefined) {
            //   if (response[Complete_question_details.question_id] !== dropDownValues[Complete_question_details.value_id]) {
            //     enqueueSnackbar("Please answer complete question as YES", {
            //       variant: 'warning'
            //     })
            //     return;
            //   }
            // }
             
            const result = updateSaveAnswers({
              body: {
                values: response,
                caseid: caseId,
                user: getMSID(),
                status: SAVE,
                report: reportName
              }, config: tokenConfig
            });
            result.then(res => {
              if (res.data.error) {
                throw new Error(res.data.message)
              }
              enqueueSnackbar("Submit was successful", {
                variant: 'success'
              })
              setLoaderData({ display: false, message: '' });
              closePopup();

            })
              .catch(err => {
                enqueueSnackbar(`something went wrong ${err.message}`, {
                  variant: 'error'
                });
                AppInsight.trackEvent({ name: `RQA => Submitting answers Error, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in submitting answers" } });

              });
          }}>Submit</Button>
        </Grid2>
      </Grid2>
      {/* </WithConditional> */}
    </Fragment>
  )
}

export default ReportScreenPopup;
